import { register } from '../../../JavaScript/Utils'

const DownloadForm = el => {
  const init = () => {
    const formCta = el.querySelector('.cta-download-form')
    const formContainer = el.querySelector('.hubspot-download-form')
    const downloadContainer = el.querySelector('.download-items')
    const hbspt = window.hbspt

    formCta.onclick = function () {
      formContainer.classList.add('is--visible')
      formCta.classList.add('is--hidden')
    }

    hbspt.forms.create({
      target: '.hubspot-download-form',
      region: 'na1',
      portalId: '7522205',
      formId: 'd2302e57-8181-4354-913a-5319ba66008b',
      onFormReady: form => {
        const setFrameHeight = () => {
          const formFrame = formContainer.querySelector('.hs-form-iframe')
          const frameHeight = formFrame.contentDocument.body.offsetHeight
          formFrame.style.height = `${frameHeight}px`
        }

        // Since the onFormReady from hbspt is not working correctly, this is needed
        // Also a combination of onFormReady and window.load Event does not work
        window.setTimeout(setFrameHeight, 1000)
      },
      onFormSubmitted: form => {
        downloadContainer.classList.add('is--visible')
        downloadContainer.scrollIntoView(true)
        window.scrollBy(0, -10)
      }
    })
  }

  init()
}

register('DownloadForm', DownloadForm)
